var _rect, _rect2, _rect3, _text, _text2, _text3, _circle, _circle2, _path, _rect4, _text4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpactsphere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#241d3c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#faf8ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#6b4fd3"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 122,
    fontFamily: "Arial",
    fontSize: 28,
    fontWeight: 700,
    fill: "#fff"
  }, "IMPACTSPHERE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 260,
    fontFamily: "Arial",
    fontSize: 58,
    fontWeight: 700,
    fill: "#271d48"
  }, "People. Purpose. Progress.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 310,
    fontFamily: "Arial",
    fontSize: 23,
    fill: "#716b82"
  }, "Building stronger communities together.")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 390,
    r: 150,
    fill: "#e8ddff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 390,
    r: 86,
    fill: "#6b4fd3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M920 285v210M815 390h210",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 420,
    width: 240,
    height: 64,
    rx: 32,
    fill: "#ef6e5b"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 177,
    y: 460,
    fontFamily: "Arial",
    fontSize: 20,
    fontWeight: 700,
    fill: "#fff"
  }, "Our impact")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 540,
    width: 700,
    height: 18,
    rx: 9,
    fill: "#e6e0f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 540,
    width: 510,
    height: 18,
    rx: 9,
    fill: "#6b4fd3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactsphere);
export default __webpack_public_path__ + "static/media/impactsphere.1059112a1e2299c0ab99900b4c1cf4bf.svg";
export { ForwardRef as ReactComponent };